import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TradeCategoryForm } from 'src/app/classes/form-groups/trade-category-form';
import { TradeSpecialtyCategoryForm } from 'src/app/classes/form-groups/trade-specialty-category-form';
import {
  PrimaryTrade,
  TradeCategory,
  TradeSpecialtyCategory
} from 'src/app/classes/models';
import { ToastService } from 'src/app/services/toast.service';
import { TradeService } from 'src/app/services/trade.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-add-edit-trade-specialty-category',
  templateUrl: './add-edit-trade-specialty-category.component.html',
  styleUrl: './add-edit-trade-specialty-category.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AddEditTradeSpecialtyCategoryComponent {
  constructor(
    private activeModal: NgbActiveModal,
    private UtilityService: UtilityService,
    private ToastService: ToastService,
    private TradeService: TradeService
  ) {
    this.loadTrades();
    this.loadTradeCategories();
  }

  @Input() TradeSpecialtyCategory?: TradeSpecialtyCategory;

  TradeSpecialtyCategoryForm: TradeSpecialtyCategoryForm =
    new TradeSpecialtyCategoryForm();
  trades?: PrimaryTrade[];
  categories?: TradeCategory[];

  loadTrades(query = {}) {
    this.TradeService.getTrades(
      this.UtilityService.stringifyObjectsInQueryObject(query)
    ).subscribe({
      next: (trades) => (this.trades = trades)
    });
  }

  loadTradeCategories(query = {}) {
    this.TradeService.getTradeCategories(
      this.UtilityService.stringifyObjectsInQueryObject(query)
    ).subscribe({
      next: (categories) => (this.categories = categories)
    });
  }

  close(reason?: string) {
    this.activeModal.dismiss(reason);
  }

  save() {
    const errors = this.UtilityService.generateValidationErrorsObject(
      this.TradeSpecialtyCategoryForm
    );

    if (errors) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot save. Form has errors.',
        { returnError: true }
      );
    }

    if (!this.TradeSpecialtyCategory) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot save. No Trade Category found.',
        { returnError: true }
      );
    }

    Object.assign(
      this.TradeSpecialtyCategory,
      this.TradeSpecialtyCategoryForm.getRawValue()
    );

    this.activeModal.close();
  }

  ngOnInit(): void {
    if (this.TradeSpecialtyCategory) {
      this.TradeSpecialtyCategoryForm.patchValue(this.TradeSpecialtyCategory);

      const { id } = this.TradeSpecialtyCategory;

      if (id) {
        this.TradeSpecialtyCategoryForm.controls.PrimaryTradeId.disable();
      }
    }
  }
}
